import React, { useEffect } from "react";
import "../../cssfiles/homepage.css";
import Checkbox from '@mui/material/Checkbox';
import { ThemeContext } from "../Homepage";
import { useContext } from "react";
import LK_CheckboxChecked from "../../images/LK_CheckboxChecked";
import LK_CheckboxUnchecked from "../../images/LK_CheckboxUnchecked";

export default function CustomCheckbox({ defaultChecked, checked, onChange, disabled, width, height, id, style }) {
    const { theme } = useContext(ThemeContext);

    const handleChange = event => {
        onChange(event.target.checked, event);
    };

    return (
        <Checkbox 
            icon={<LK_CheckboxUnchecked color={disabled === true ? (theme === 'light' ? '#C1C1C1' : '#3C3C3C') : '#008CD7'} width={width ? `${width}px` : "13px"} height={height ? `${height}px` : "13px"} />}
            checkedIcon={<LK_CheckboxChecked color={disabled === true ? (theme === 'light' ? '#C1C1C1' : '#3C3C3C') : '#008CD7'} width={width ? `${width}px` : "13px"} height={height ? `${height}px` : "13px"} />}
            disabled={disabled !== null ? disabled : false}
            defaultChecked={defaultChecked != null ? (typeof(defaultChecked) === "string" ? defaultChecked === "true" ? true : false : defaultChecked ? true : false) : false} 
            checked={checked}
            onChange={handleChange} 
            id={id != null ? id : null}
            sx={{
                padding: 0,
                margin: 0,
                color: '#008CD7',
                '& .MuiSvgIcon-root': {
                    fontSize: '20px',
                    color: '#008CD7',
                    fill: disabled === true ? (theme === 'light' ? '#C1C1C1' : '#3C3C3C') : '#008CD7',
                },
                ...style
            }} 
        />
    );
}